import type { FC, ReactNode } from "react";

interface FloatingCardProps {
  children: ReactNode;
  className?: string;
  padding?: "none" | "sm" | "md" | "lg";
}

export const FloatingCard: FC<FloatingCardProps> = ({
  children,
  className = "",
  padding = "md",
}) => {
  const paddingClasses = { lg: "p-4", md: "p-3", none: "", sm: "p-2" };

  return (
    <div
      className={`rounded-none border border-slate-300 bg-white text-gray-900 shadow-sm dark:border-2 dark:border-slate-700 dark:bg-arti-panel dark:text-white ${paddingClasses[padding]} ${className}`
        .trim()
        .replace(/\s+/g, " ")}
    >
      {children}
    </div>
  );
};
